import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserOrders } from "../../appState/slices/order/orderSlice";
import "./myorders.css"
import OrderDiv from "./OrderDiv";
import Empty from "../EmptyComponent/Empty";

const MyOrders = () => {
    const orders = useSelector(state => state.order.orders);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getUserOrders());
    }, [])
    const reversedOrders = [...orders].reverse();
    return (
        <div>
            <hr className="myorders-line"></hr>
            <div className="single-order-fixed">
                <div className="myordercontainer">
                    {orders.length === 0 ? (
                        <Empty icon="SmileySad" title="You have not placed any orders yet" subtitle="Purchase new products and be a part of Purecarats." />
                    ) : (
                        reversedOrders.map(order => (
                            <React.Fragment>
                                {order.orderCompleted ?
                                    <OrderDiv key={order.id} order={order} />
                                    :
                                    null
                                }
                            </React.Fragment>
                        ))
                    )}
                </div>
            </div>

        </div>
    )
}

export default MyOrders;